import React from 'react';
import { ChevronRight } from 'lucide-react';

const NavItem = ({ icon, label, active, onClick }) => (
  <div 
    className={`flex items-center space-x-3 px-4 py-3 cursor-pointer rounded-lg transition-colors ${
      active ? 'bg-blue-100 text-blue-700' : 'hover:bg-gray-100'
    }`}
    onClick={onClick}
  >
    {icon}
    <span className="font-medium">{label}</span>
    {active && <ChevronRight size={16} className="ml-auto" />}
  </div>
);

export default NavItem; 